import Skeleton from 'src/Admin/components/common/skeleton';
import MemberSelectedItemComponent from './MemberSelectedItemComponent';

const MemberSideModal = ({
  data,
  skeletonLoader,
  isServerError,
  setMemberListData,
  dataFetching,
}) => {
  const onChangeHandler = (e, memId = '') => {
    const { id } = e.target;
    console.log('debug_perOnChange', id, data, memId);
    const updatedItems = data?.map((item) =>
      item?.OID === id
        ? { ...item, memberID: memId, isChecked: true }
        : { ...item, memberID: memId, isChecked: false },
    );
    setMemberListData(updatedItems);
  };

  return (
    <div>
      <div className="provider-side-panel-disclaimer">
        {dataFetching ? (
          <div className="pr-4">
            <Skeleton count={1} height={30} />
          </div>
        ) : data?.length && !isServerError ? (
          <>
            <>
              Found {data?.length} Result{data?.length > 1 && `s`}
            </>
            <hr />
          </>
        ) : null}
      </div>

      <div className="reports-modal-devider" />
      <div className="blob-lists physician">
        {!dataFetching && !(isServerError || !data.length) ? (
          data?.map((item, index) => (
            <div className="physician-list-item" key={index}>
              <MemberSelectedItemComponent
                onChangeHandler={onChangeHandler}
                item={item}
              />
            </div>
          ))
        ) : dataFetching ? (
          <Skeleton count={15} height={30} />
        ) : isServerError && !data.length ? (
          <div className="more-spl pt-3">
            No results found! We could not find any Member/Dependent with the
            values that you have entered. Try again using other values.
          </div>
        ) : (
          ''
        )}
      </div>
    </div>
  );
};

export default MemberSideModal;
